/**
 * Extract all price IDs from expression string containing {{id}} placeholders
 * @param expression - The expression string containing {{id}} pattern(s), e.g. "{{3388}}/{{1}}/{{73}}"
 * @returns Array of extracted price IDs as numbers, or empty array if none found
 */
export const extractPriceIdsFromExpression = (expression?: string): number[] => {
  if (!expression) return []

  const priceIdPattern = /\{\{(\d+)\}\}/g
  const matches = expression.match(priceIdPattern)

  if (!matches) return []

  return matches
    .map(match => {
      const idMatch = /\{\{(\d+)\}\}/.exec(match)
      return idMatch ? Number(idMatch[1]) : 0
    })
    .filter(id => id > 0)
}
